import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Remediation } from '../../../shared/vulns/Drawer';
import type { VulnIssue } from '../../../../../shared/issuesV2';

/**
 * VulnerabilityIssueDetailsRemediation displays the remediation info
 * of the vulnerability currently being viewed.
 */
const VulnerabilityIssueDetailsRemediation: VoidFunctionComponent = () => {
  const activeIssue = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;

  if (!activeIssue || activeIssue.source.packageManager === 'csbinary') {
    return null;
  }

  /**
   * User-defined dependencies can have vuln issues due to CPEs in the SBOM file.
   * However, they don't have a remediation guidance, but we still want to show an unable to calculate message.
   */
  const isUserDefinedDependency = activeIssue.source?.packageManager === 'user';

  return (
    <Remediation
      version={activeIssue.source?.version ?? ''}
      //  Note: we need to expand the API response to include both.
      completeFix={activeIssue.remediation?.completeFix}
      completeFixDistance={activeIssue.remediation?.completeFixDistance}
      partialFix={activeIssue.remediation?.partialFix}
      isUserDefinedDependency={isUserDefinedDependency}
    />
  );
};

export default VulnerabilityIssueDetailsRemediation;
